import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  TextField,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useDispatch, useSelector } from "react-redux";
import { search_product } from "../../actions/sales";
import { all_customer_list } from "../../actions/customer";
import { bindActionCreators } from "redux";
import * as salesAction from "../../actions/sales";
import { useLocation, useNavigate } from "react-router-dom";

const Sales = () => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState(null);
  const [customer, setCustomer] = useState();
  const [invoice, setInvoice] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const sales = useSelector((state) => state?.sales?.search_data);
  const product_data = useSelector((state) => state?.sales?.product_data);
  const { product_detail } = bindActionCreators(salesAction, dispatch);
  const user = useSelector((state) => state.layout.profile);
  const customers = useSelector((state) => state.customers.customers);
  const [disPlay, setDisplay] = useState([]);
  const [cusOption, SetCusOption] = useState([]);
  const [searchField, SetSearchField] = useState();
  const [productData, setProductData] = useState([]);
  const [editPrice, setEditPrice] = useState([]);
  const [sgst, setSgst] = useState();
  const [cgst, setCgst] = useState();
  const [cgstPrice, setCgstPrice] = useState(0);
  const [sgstPrice, setSgstPrice] = useState(0);
  const [igstPrice, setIgstPrice] = useState(0);
  const [igst, setIgst] = useState(0);
  const [priceFinal, setPriceFinal] = useState();
  const [priceAfterTax, setPriceAfterTax] = useState(priceFinal);
  const [review, setReview] = useState("");
  const [openApproval, setOpenApproval] = useState(false);
  const [invoiceErr, setInvoiceErr] = useState(false);
  const [content, setContent] = useState("");

  const message = useSelector((state) => state.layout.message);

  // console.log(productData, product_data, "newProductData");

  const [quantity, SetQuantity] = useState(1);

  const [proOption, SetProOption] = useState([]);

  const [date, setDate] = useState(dayjs(new Date()));
  const cus_id = location?.state?.cus_id;
  const cus = location?.state?.cus;
  const editProductData = location?.state?.product_data;
  const isEdit = location?.state?.isEditBill 
  const edit_invoice_id = location?.state?.product_data?.invoice_id 

  console.log(location?.state, "Cheheheheheheheh");

  console.log(cus_id, location, cus, "newSalvw");
  const handleSearchChange = (event) => {
    const data = event.target.value;
    if (data == "" || null) {
      SetSearchField("");
    } else {
      SetSearchField(data);
    }
    let userObj = {
      // user_id: user_id,
      search: event.target.value,
    };
    dispatch(search_product(userObj));
    // SetSearchField("")
  };

  useMemo(() => {
    if (sales?.data) {
      const temp = [];
      const temp2 = productData.map((val) => val.id);
      sales?.data.map((val) => !temp2.includes(val.id) && temp.push(val));

      setDisplay([...temp]);
    }
  }, [sales?.data]);
  useMemo(() => {
    if (location) {
      SetSearchField();
      setProductData([]);
      setInvoice("");
      setDate(dayjs(new Date()));
      setReview("");
      setDisplay([]);
    }
  }, [location]);

  useMemo(() => {
    if (isEdit) {
      const editProductDataList =
        editProductData &&
        editProductData?.data?.map((ele ,index) => ({
          ...ele?.product,
          selling_price: ele?.selling_price,
           quantity: ele?.quantity,
        product_igst_price : ele?.product_igst,
        product_sgst_price : ele?.product_sgst,
        product_cgst_price : ele?.product_cgst,
        product_final_price: ele?.final_price


        }));
      console.log(editProductDataList, "Heeeeeeeeeee");
      setProductData(editProductDataList);
      setInvoice(location?.state?.Invoice);
      setDate(dayjs(editProductData?.date))
    }
  }, [isEdit]);

  console.log(productData ,"sdfsdfdsfdsfdsf")
  const handlequantityChange = (event, index) => {
    const data = event.target.value;
    const temp = productData;
    // temp[index]["selling_price"] = data;
    temp[index]["quantity"] = data;
    // const temp = productData
    if (cus?.state == "Gujarat") {
      temp[index]["product_sgst_price"] =
        data * temp[index]["selling_price"] * Number(temp[index]["gst_rate"] / 200);
      temp[index]["product_cgst_price"] =
        data * temp[index]["selling_price"] *Number(temp[index]["gst_rate"] / 200);
      temp[index]["product_igst_price"] = 0;
    } else {
      temp[index]["product_igst_price"] =
        data * temp[index]["selling_price"] * Number(temp[index]["gst_rate"] / 100);
      temp[index]["product_sgst_price"] = 0;
      temp[index]["product_cgst_price"] = 0;
    }

    temp[index]["product_final_price"] =
      data * temp[index]["selling_price"] -
      temp[index]["product_sgst_price"] -
      temp[index]["product_cgst_price"] -
      temp[index]["product_igst_price"];
    setProductData([...temp]);
    // SetQuantity(data);
  };
  // const handlequantityChange = (event ,index) => {
  //   const data = event.target.value;
  //   const temp = productData
  //   // temp[index]["selling_price"] = data;
  //   temp[index]["quantity"] =  data
  //   // const temp = productData
  //   temp[index]["product_final_price"] = data * temp[index]["selling_price"]
  //   setProductData([...temp])
  //   // SetQuantity(data);
  // };

  const handleProduct = async (id) => {
    console.log(id, "newID");
    const resData = await product_detail({ id: id });
    SetSearchField("");
    setProductData([...productData, resData?.data]);
    // const temp = disPlay;
    // temp.map((val, index) => val.id == id && temp.splice(index, 1));
    // setDisplay([...temp]);
    // console.log(temp, "pdffdf");
  };
  const [customerData, setCustomerData] = useState({
    cus_email: "",
    cus_state: "",
    cus_city: "",
    cus_pincode: "",
    cus_address: "",
    cus_id: "",
  });
  useMemo(() => {
    if (customer && customers) {
      const foundCustomer = customers.data.find(
        (val) => customer === val?.name
      );
      if (foundCustomer) {
        setCustomerData({
          cus_email: foundCustomer.email,
          cus_state: foundCustomer.state,
          cus_city: foundCustomer.city,
          cus_pincode: foundCustomer.pincode,
          cus_address: foundCustomer.address,
          cus_id: foundCustomer.id,
        });
      }
    }
  }, [customer, customers]);
  console.log(customerData, "CUSNEWWW");

  const product = [];
  useMemo(() => {
    if (productData) {
      let sum = 0;
      let sgst_final = 0;
      let cgst_final = 0;
      let igst_final = 0;

      productData.forEach(
        (val) => (
          cus?.state == "Gujarat" &&
            (sgst_final += Number(
              val?.product_sgst_price
                ? val?.product_sgst_price
                : val?.selling_price * Number(val?.gst_rate / 200)
            )),
          cus?.state == "Gujarat" &&
            (cgst_final += Number(
              val?.product_cgst_price
                ? val?.product_cgst_price
                : val?.selling_price * Number(val?.gst_rate / 200)
            )),
          cus?.state != "Gujarat" &&
            (igst_final += Number(
              val?.product_igst_price
                ? val?.product_igst_price
                : val?.selling_price * Number(val?.gst_rate / 100)
            )),
          (sum += Number(
            val?.product_final_price
              ? val?.product_final_price
              : val?.selling_price - Number(val?.selling_price * Number(val?.gst_rate / 100))
          ))
        )
      );
      console.log(productData, sum, igst_final, "newArr");

      setPriceFinal(sum);
      setCgstPrice(cgst_final);
      setSgstPrice(sgst_final);
      setIgstPrice(igst_final);

      // for (var i = 0; i < productData.length; i++) {
      //   product.push({
      //     product: productData.map((product) => product?.id).filter((e) => e),
      //   });
      // }
    }
  }, [productData]);

  useMemo(() => {
    if (cgst) {
      setCgstPrice((cgst * priceFinal) / 100);
    }
  }, [cgst, cgstPrice]);
  useMemo(() => {
    if (sgst) {
      setSgstPrice((sgst * priceFinal) / 100);
    }
  }, [sgst, sgstPrice]);
  useMemo(() => {
    if (igst) {
      setIgstPrice((igst * priceFinal) / 100);
    }
  }, [igst, igstPrice]);
  useMemo(() => {
    setPriceAfterTax(priceFinal - cgstPrice - sgstPrice - igstPrice);
  }, [priceFinal, cgstPrice, sgstPrice, igstPrice]);

  useEffect(() => {
    if (user) {
      const data = new FormData();
      data.append("id", user?.id);
      dispatch(all_customer_list(data));
    }
  }, [user]);
  useMemo(() => {
    if (customers?.statuscode == 200) {
      const cusList = customers?.data.map((ele) => ele?.name);
      // console.log(cusList, "newCUS");
      SetCusOption(cusList);
    }
  }, [customers]);

  const handlePriceChange = (event, index) => {
    const data = event.target.value;
    const temp = productData;
    temp[index]["selling_price"] = data;
    if (cus?.state == "Gujarat") {
      temp[index]["product_sgst_price"] = data * temp[index]["quantity"] * Number(temp[index]["gst_rate"] / 200) ;
      temp[index]["product_cgst_price"] = data * temp[index]["quantity"] * Number(temp[index]["gst_rate"] / 200) ;
      temp[index]["product_igst_price"] = 0;
    } else {
      temp[index]["product_igst_price"] = data * temp[index]["quantity"] * Number(temp[index]["gst_rate"] / 100);
      temp[index]["product_sgst_price"] = 0;
      temp[index]["product_cgst_price"] = 0;
    }

    temp[index]["product_final_price"] =
      temp[index]["quantity"] * temp[index]["selling_price"] -
      temp[index]["product_sgst_price"] -
      temp[index]["product_cgst_price"] -
      temp[index]["product_igst_price"];
    // temp[index]["product_final_price"] =   * temp[index]["selling_price"];
    // setProductData([...temp]);
    setProductData([...temp]);
    // setEditPrice([...temp])
  };
  console.log(editPrice, "NewPrice");
  useMemo(() => {
    if (sales?.statuscode == 200) {
      const salList = sales?.data.map((ele) => ele?.product_name);
      console.log(salList, "newCUS123");
      SetProOption(salList);
    }
  }, [sales]);
  console.log(customer, date, invoice, "newCl");
  console.log(productData, "sales123");

  const PRod = {};
  for (var i = 0; i < productData.length; i++) {
    PRod["product_" + i] = productData?.[i]["id"];
    PRod["selling_price_" + i] = parseFloat(
      productData?.[i]["selling_price"]
    ).toFixed(2);
    PRod["quantity_" + i] = productData?.[i]["quantity"]
      ? productData?.[i]["quantity"]
      : "1";
    PRod["final_price_" + i] = productData?.[i]["product_final_price"]
      ? parseFloat(productData?.[i]["product_final_price"]).toFixed(2)
      : parseFloat(Number(productData?.[i]["selling_price"])).toFixed(2);

    PRod["product_sgst_" + i] = productData?.[i]["product_sgst_price"]
      ? parseFloat(productData?.[i]["product_sgst_price"]).toFixed(2)
      : parseFloat(Number(productData?.[i]["selling_price"] * Number(productData?.[i]["gst_rate"] / 200))).toFixed(2);

    PRod["product_cgst_" + i] = productData?.[i]["product_cgst_price"]
      ? parseFloat(productData?.[i]["product_cgst_price"]).toFixed(2)
      : parseFloat(Number(productData?.[i]["selling_price"] * Number(productData?.[i]["gst_rate"] / 200))).toFixed(2);

    PRod["product_igst_" + i] = productData?.[i]["product_igst_price"]
      ? parseFloat(productData?.[i]["product_igst_price"]).toFixed(2)
      : parseFloat(Number(productData?.[i]["selling_price"] * Number(productData?.[i]["gst_rate"] / 100))).toFixed(2);
    // selling_price : productData?.["selling_price"],
  }
  // const PRod = productData.flatMap((item, index) => [
  //   {
  //     ["product_" + index]: item["id"],
  //     ["selling_price_" + index]: item["selling_price"],
  //     ["quantity_" + index]: item["quantity"] ? item["quantity"] : "1",
  //     ["product_final_price_" + index]: item["product_final_price"] ? item["product_final_price"] : Number(item["selling_price"]),
  //   }
  // ]);
  const dateFor = new Date(date);

  // Extract day, month, and year components
  const day = dateFor.getDate();
  const month = dateFor.getMonth() + 1; // Month is 0-indexed, so we add 1
  const year = dateFor.getFullYear();

  // Format the components into dd/mm/yyyy format
  // const formattedDate = `${day.toString().padStart(2, "0")}/${month
  //   .toString()
  //   .padStart(2, "0")}/${year}`;
  const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;
  console.log(formattedDate, "newFORMATED");
  const handleEmptyField = (event) => {
    invoice == "" ? setInvoiceErr(true) : setInvoiceErr(false);
    if (productData.length == 0 && invoice == "") {
      setOpenApproval(true);
      setContent("Please Add Products And Invoice Number");
    } else if (productData.length != 0 && invoice == "") {
      setOpenApproval(true);
      setContent("Please Add Invoice Number");
    } else if (productData.length == 0 && invoice != "") {
      setOpenApproval(true);
      setContent("Please Add Products");
    } else {
      setOpenApproval(false);
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData();
    const grandTotal = parseFloat(
      priceFinal + cgstPrice + igstPrice + sgstPrice
    ).toFixed(2);
    Object.entries(PRod).forEach(([key, value]) => {
      data.append(key, value);
    });

    data.append("customer", cus_id);
    data.append("date", formattedDate);
    data.append("invoice", invoice);
    data.append("review", review);
    if (cus?.state == "Gujarat") {
      data.append("total_sgst", parseFloat(sgstPrice).toFixed(2));
      data.append("total_cgst", parseFloat(cgstPrice).toFixed(2));
    } else {
      data.append("total_igst", parseFloat(igstPrice).toFixed(2));
    }
    data.append("amount_before_tax", parseFloat(priceFinal).toFixed(2));
    data.append("grand_total", grandTotal);

    // for (const pair of data.entries()) {
    //   console.log(pair[0] + ': ' + pair[1] ,"FoDate");
    // }
    if(isEdit){
      data.append("id" , edit_invoice_id)
    dispatch(salesAction.product_sale_update(data));
    }else{

      dispatch(salesAction.product_sale_create(data));
    }
    setTimeout(() => {
      setProductData([]);
      setInvoice("");
      setCustomer();
      setDate();
      setPriceFinal();
      setInvoiceErr(false);
    }, 500);
  };
  const handleClose = () => {
    setOpenApproval(false);
  };
  console.log(PRod, "newAd");
  useMemo(() => {
    if (message?.statuscode == 200) {
      // setIsEdit(false);

      // setForm({});
      setTimeout(() => {
        // const data = new FormData();
        // data.append("id", user?.id);
        dispatch(salesAction.all_product_sale_detail());
        navigate("/AllSaleList/AllSaleList", { state: { view: "view_all" } });
        // setView("view_all");
      }, 900);
    }
  }, [message]);
  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={openApproval}
        autoHideDuration={1500}
        onClose={handleClose}
      >
        <Alert severity="info" variant="filled" color="success">
          {content}
        </Alert>
      </Snackbar>
      <div
        style={{
          background: "#fff",
          padding: "1rem",
          marginTop: "0.5rem",
          borderRadius: "10px",
        }}
      >
        <div style={{display:"flex" ,justifyContent:"space-between" , alignItems:"end"}}>
          <div>
        <div className="ss_prj_main">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "75%",
              marginTop: "2rem",
            }}
          >
            <div style={{ display: "flex", gap: "3rem" }}>
              {/* <Autocomplete
              disablePortal
              value={customer}
              onChange={(event, newValue) => {
                setCustomer(newValue);
              }}
              id="combo-box-demo"
              options={cusOption}
              sx={{ width: 400, my: 1 }}
              renderInput={(params) => (
                <TextField {...params} label="Select Customer" />
              )}
            /> */}
              <div style={{ marginTop: "0.5rem" }}>
                <TextField
                  id="outlined-basic"
                  label="Invoice No"
                  variant="outlined"
                  value={invoice}
                  required
                  helperText={invoiceErr && "please fill this field"}
                  onChange={(e) => setInvoice(e.target.value)}
                />
              </div>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    label="Purchase Order Date"
                    value={date}
                    onChange={(newValue) => setDate(newValue)}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>

            {/* <div
            style={{
              display: customer ? "flex" : "none",
              justifyContent: "space-between",
            }}
          >
            <div style={{ marginTop: "0.5rem" }}>
              <TextField
                id="email_id"
                label="Email Id"
                variant="outlined"
                disabled
                value={customerData?.cus_email}
                // onChange={(e) => setInvoice(e.target.value)}
              />
            </div>
            <div style={{ marginTop: "0.5rem" }}>
              <TextField
                id="state"
                label="State"
                variant="outlined"
                disabled
                value={customerData?.cus_state}
                // onChange={(e) => setInvoice(e.target.value)}
              />
            </div>
            <div style={{ marginTop: "0.5rem" }}>
              <TextField
                id="city"
                label="City"
                variant="outlined"
                disabled
                value={customerData?.cus_city}
                // onChange={(e) => setInvoice(e.target.value)}
              />
            </div>
            <div style={{ marginTop: "0.5rem" }}>
              <TextField
                id="address"
                label="Address"
                variant="outlined"
                disabled
                value={customerData?.cus_address}
                // onChange={(e) => setInvoice(e.target.value)}
              />
            </div>
            <div style={{ marginTop: "0.5rem" }}>
              <TextField
                id="pin_code"
                label="Pincode"
                variant="outlined"
                disabled
                value={customerData?.cus_pincode}
                // onChange={(e) => setInvoice(e.target.value)}
              />
            </div>
          </div> */}
          </div>
          
        </div>
        <div className="">
          {/* <Autocomplete
          disablePortal
          // value={customer}
          onChange={(event) => handleSearchChange(event)}
          id="combo-box-demo"
          options={proOption}
          sx={{ width: 900, my: 1 }}
          renderInput={(params) => (
            <TextField {...params} label="Select Product..." />
          )}
        /> */}
          <input
            type="text"
            name="search-val"
            // size="100"
            // height="50px"
            // width="500px"
            value={searchField}
            className="cfield"
            aria-required="true"
            aria-invalid="false"
            placeholder="Search Product ..."
            onChange={(event) => handleSearchChange(event)}
            autoComplete="off"
          />
          <div
            className={
              sales != null && (searchField != "" || null)
                ? "displayItems123"
                : "displaynone123"
            }
          >
            {disPlay?.length
              ? disPlay
                  ?.slice(0, 5)
                  .map((data, index) => (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => handleProduct(data?.id)}
                    >
                      <ul key={index} className="ul-style">
                        <li>{data?.product_name}</li>
                      </ul>
                      {/* <p className="ul-style">{data?.product_name}</p> */}
                    </div>
                  ))
                  .filter((e) => e)
              : searchField && (
                  <p
                    style={{
                      color: "#000",
                      textAlign: "center",
                      width: "900px",
                      padding: "10px",
                      padding_eft: "20px",
                    }}
                  >
                    No result found.
                  </p>
                )}
          </div>
        </div>
        </div>
        <div>
          <div style={{marginRight:"5rem"}}>
            <div style={{color:"black" , display:"flex" , fontSize:"20px"}}><p style={{fontWeight:"700" , width:"60px"}}>Name</p> : -   <span style={{paddingLeft:"1rem"}}>{location?.state?.cus?.name}</span></div>
            <div style={{color:"black" , display:"flex" ,  fontSize:"20px"}}><span style={{fontWeight:"700" , width:"60px"}}>City</span> : -   <span style={{paddingLeft:"1rem"}}>{location?.state?.cus?.city}</span></div>
          </div>
        </div>
        </div>
        <div style={{ borderRadius: "0.5rem", overflow: "hidden" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "12px",
              background: "#ffffff",
              marginTop: "5rem",
              color: "#000",
              // borderRadius:"0.5rem"
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #9b9393",
                    padding: "10px",
                    textAlign: "center",
                    // borderRadius: "10px",
                  }}
                >
                  HSN
                </th>
                <th
                  style={{
                    border: "1px solid #9b9393",
                    padding: "10px",
                    textAlign: "center",
                    // borderRadius: "10px",
                  }}
                >
                  Name
                </th>
                <th
                  style={{
                    border: "1px solid #9b9393",
                    padding: "10px",
                    textAlign: "center",
                    // borderRadius: "10px",
                  }}
                >
                  Units
                </th>
                <th
                  style={{
                    border: "1px solid #9b9393",
                    padding: "10px",
                    textAlign: "center",
                    // borderRadius: "10px",
                  }}
                >
                  Qty
                </th>
                {/* <th
                style={{
                  border: "1px solid #9b9393",
                  padding: "10px",
                  textAlign: "center",
                  borderRadius: "10px",
                }}
              >
                Cost
              </th> */}
                <th
                  style={{
                    border: "1px solid #9b9393",
                    padding: "10px",
                    textAlign: "center",
                    // borderRadius: "10px",
                  }}
                >
                 Purchase Price
                </th>
                <th
                  style={{
                    border: "1px solid #9b9393",
                    padding: "10px",
                    textAlign: "center",
                    // borderRadius: "10px",
                  }}
                >
                 Selling Price
                </th>
                {cus?.state == "Gujarat" && (
                  <th
                    style={{
                      border: "1px solid #9b9393",
                      padding: "10px",
                      textAlign: "center",
                      // borderRadius: "10px",
                    }}
                  >
                    SGST
                  </th>
                )}
                {cus?.state == "Gujarat" && (
                  <th
                    style={{
                      border: "1px solid #9b9393",
                      padding: "10px",
                      textAlign: "center",
                      // borderRadius: "10px",
                    }}
                  >
                    CGST 
                  </th>
                )}
                {cus?.state != "Gujarat" && (
                  <th
                    style={{
                      border: "1px solid #9b9393",
                      padding: "10px",
                      textAlign: "center",
                      // borderRadius: "10px",
                    }}
                  >
                    IGST 
                  </th>
                )}
                <th
                  style={{
                    border: "1px solid #9b9393",
                    padding: "10px",
                    textAlign: "center",
                    // borderRadius: "10px",
                  }}
                >
                  Total Price
                </th>
              </tr>
            </thead>
            <tbody>
              {productData.map((data, index) => (
                <tr key={"12"}>
                  <td
                    style={{
                      border: "1px solid #9b9393",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    {data?.HSN}
                  </td>
                  <td
                    style={{
                      border: "1px solid #9b9393",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    {data?.product_name}
                  </td>
                  <td
                    style={{
                      border: "1px solid #9b9393",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    {data?.unit_of_measure?.unit_name}
                  </td>
                  <td
                    style={{
                      border: "1px solid #9b9393",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    <div className="Qty_div">
                      <input
                        type="number"
                        defaultValue="1"
                        value={isEdit ? data?.quantity : null}
                        min="1"
                        onChange={(event) => handlequantityChange(event, index)}
                      />
                    </div>
                  </td>
                    <td
                    style={{
                      border: "1px solid #9b9393",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    {parseFloat(data?.purchase_price).toFixed(2)}
                  </td>
                  <td
                    style={{
                      border: "1px solid #9b9393",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    <div className="Price_div">
                      <input
                        type="number"
                        // defaultValue={data?.selling_price}
                        // name={`price_${index}`}
                        value={data?.selling_price}
                        min="1"
                        onChange={(event) => handlePriceChange(event, index)}
                      />
                    </div>
                  </td>
                  {cus?.state == "Gujarat" && (
                    <td
                      style={{
                        border: "1px solid #9b9393",
                        padding: "10px",
                        textAlign: "center",
                      }}
                    >
                      {/* <div className="Price_div">
                    <input
                      type="number"
                      // defaultValue={data?.selling_price}
                      // name={`price_${index}`}
                      value={data?.selling_price}
                      min="1"
                      onChange={(event) => handlePriceChange(event, index)}
                    />
          
                  </div> */}
                      {/* {sgstPrice == 0 ? } */}
                      {parseFloat(
                        data?.product_sgst_price
                          ? data?.product_sgst_price
                          : data?.selling_price * Number(data?.gst_rate /200)
                      ).toFixed(2) + ` (${data?.gst_rate / 2} %)`} 
                    </td>
                  )}
                  {cus?.state == "Gujarat" && (
                    <td
                      style={{
                        border: "1px solid #9b9393",
                        padding: "10px",
                        textAlign: "center",
                      }}
                    >
                      {/* <div className="Price_div">
                    <input
                      type="number"
                      // defaultValue={data?.selling_price}
                      // name={`price_${index}`}
                      value={data?.selling_price}
                      min="1"
                      onChange={(event) => handlePriceChange(event, index)}
                    />
          
                  </div> */}
                      {parseFloat(
                        data?.product_cgst_price
                          ? data?.product_cgst_price
                          : data?.selling_price * Number(data?.gst_rate /200)
                      ).toFixed(2) + ` (${data?.gst_rate/2} %)`} 
                    </td>
                  )}
                  {cus?.state != "Gujarat" && (
                    <td
                      style={{
                        border: "1px solid #9b9393",
                        padding: "10px",
                        textAlign: "center",
                      }}
                    >
                      {/* <div className="Price_div">
                    <input
                      type="number"
                      // defaultValue={data?.selling_price}
                      // name={`price_${index}`}
                      value={data?.selling_price}
                      min="1"
                      onChange={(event) => handlePriceChange(event, index)}
                    />
          
                  </div> */}
                      {parseFloat(
                        data?.product_igst_price
                          ? data?.product_igst_price
                          : data?.selling_price * Number(data?.gst_rate /100)
                      ).toFixed(2) + ` (${data?.gst_rate} %)`} 
                    </td>
                  )}
                  <td
                    style={{
                      border: "1px solid #9b9393",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    {/* {quantity == 1 ?  data?.selling_price : data?.quantity *data?.selling_price } */}
                    {parseFloat(
                      data?.product_final_price
                        ? data?.product_final_price
                        : data?.selling_price -
                            (data?.selling_price *Number(data?.gst_rate /100) )
                    ).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "12px",
                background: "#ffffff",
                marginTop: "5rem",
                color: "#000",
              }}
            >
              <tbody>
                {cus?.state == "Gujarat" ? (
                  <>
                    {" "}
                    <tr key={12}>
                      <td
                        style={{
                          border: "1px solid #9b9393",
                          padding: "10px",
                          textAlign: "right",
                          width: "70%",
                          paddingRight: "1rem",
                        }}
                      >
                        Total CGST
                        {/* <span className="Qty_div">
                    <input
                      type="number"
                      defaultValue="0"
                      // value={quantity}
                      min="0"
                      onChange={(event) => setCgst(event.target.value)}
                    />{" "}
                    %
                  </span> */}
                      </td>
                      <td
                        style={{
                          border: "1px solid #9b9393",
                          padding: "10px",
                          textAlign: "center",
                        }}
                      >
                        {parseFloat(cgstPrice).toFixed(2)}
                      </td>
                    </tr>
                    <tr key={12}>
                      <td
                        style={{
                          border: "1px solid #9b9393",
                          padding: "10px",
                          textAlign: "right",
                          width: "70%",
                          paddingRight: "1rem",
                        }}
                      >
                        Total SGST
                        {/* <span className="Qty_div">
                    <input
                      type="number"
                      defaultValue="0"
                      // value={quantity}
                      min="0"
                      onChange={(event) => setSgst(event.target.value)}
                    />{" "}
                    %
                  </span> */}
                      </td>
                      <td
                        style={{
                          border: "1px solid #9b9393",
                          padding: "10px",
                          textAlign: "center",
                        }}
                      >
                        {parseFloat(sgstPrice).toFixed(2)}
                      </td>
                    </tr>
                  </>
                ) : (
                  <tr key={12}>
                    <td
                      key={8}
                      style={{
                        border: "1px solid #9b9393",
                        padding: "10px",
                        textAlign: "right",
                        width: "70%",
                        paddingRight: "1rem",
                      }}
                    >
                      Total IGST{" "}
                      {/* <span className="Qty_div">
                    <input
                      type="number"
                      defaultValue="0"
                      // value={quantity}
                      min="0"
                      onChange={(event) => setIgst(event.target.value)}
                    />{" "}
                    %
                  </span> */}
                    </td>
                    <td
                      style={{
                        border: "1px solid #9b9393",
                        padding: "10px",
                        textAlign: "center",
                      }}
                    >
                      {parseFloat(igstPrice).toFixed(2)}
                    </td>
                  </tr>
                )}

                {/* <tr key={12}>
                <td
                  key={8}
                  style={{
                    border: "1px solid #9b9393",
                    padding: "10px",
                    textAlign: "right",
                    width: "70%",
                    paddingRight: "1rem",
                  }}
                >
                  Total Amount After Tax
                </td>
                <td
                  style={{
                    border: "1px solid #9b9393",
                    padding: "10px",
                    textAlign: "center",
                  }}
                >
                  {parseFloat(priceAfterTax).toFixed(2)}
                </td>
              </tr>  */}
                <tr key={12}>
                  <td
                    style={{
                      border: "1px solid #9b9393",
                      padding: "10px",
                      textAlign: "right",
                      width: "70%",
                      paddingRight: "1rem",
                    }}
                  >
                    Total Amount
                  </td>
                  <td
                    style={{
                      border: "1px solid #9b9393",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    {parseFloat(priceFinal).toFixed(2)}
                  </td>
                </tr>
                <tr key={12}>
                  <td
                    key={8}
                    style={{
                      border: "1px solid #9b9393",
                      padding: "10px",
                      textAlign: "right",
                      width: "70%",
                      paddingRight: "1rem",
                    }}
                  >
                    Grand Total
                  </td>
                  <td
                    style={{
                      border: "1px solid #9b9393",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    {parseFloat(
                      priceFinal + igstPrice + sgstPrice + cgstPrice
                    ).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{ color: "#000", marginTop: "1rem" }}>
            <label htmlFor="review">Review:</label>
            <textarea
              id="review"
              rows="5"
              value={review}
              onChange={(e) => setReview(e.target.value)}
              style={{ width: "100%", borderRadius: "10px" }}
            ></textarea>
          </div>
        </div>
        <Grid
          item
          xs={12}
          lg={12}
          key={"-grid"}
          textAlign={"center"}
          display={"block"}
        >
          <Button
            type={"button"}
            variant="contained"
            style={{
              background:
                "linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%)",
            }}
            sx={{
              mt: 1,
              textTransform: "capitalize",
              borderRadius: "8px",
              fontWeight: "500",
              fontSize: "13px",
              padding: "12px 20px",
              minWidth: "0",
              minHeight: "0",
              color: "#fff !important",
            }}
            onClick={(event) =>
              invoice !== "" && productData.length !== 0 && cus_id
                ? handleSubmit(event)
                : handleEmptyField(event)
            }
          >
            Add Sale
          </Button>
        </Grid>
      </div>
    </>
  );
};

export default Sales;
